var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "12x12/Link",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.498 4.516a.75.75 0 011.06 0 3.214 3.214 0 010 4.545l-1.997 1.998a3.214 3.214 0 01-4.545 0l-.075-.075a3.214 3.214 0 010-4.546l.402-.4A.75.75 0 012.402 7.1l-.4.4a1.712 1.712 0 000 2.423l.075.075c.669.67 1.754.67 2.423 0L6.498 8c.67-.669.67-1.754 0-2.423a.75.75 0 010-1.06zM6.439.941a3.211 3.211 0 014.54-.003l.08.078a3.214 3.214 0 010 4.546l-.402.4A.75.75 0 019.598 4.9l.4-.4c.67-.67.67-1.754.004-2.42l-.08-.078a1.712 1.712 0 00-2.422 0L5.502 4c-.67.67-.67 1.754 0 2.423a.75.75 0 01-1.06 1.06 3.214 3.214 0 010-4.544z",
    id: "Combined-Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink12);
export default __webpack_public_path__ + "static/media/link-12.cda31e44.svg";
export { ForwardRef as ReactComponent };